import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddPayment from "../../../containers/superadmin/paymentSubjects/models/add-payment";
import SearchBar from "../../../containers/superadmin/paymentSubjects/searchbar";
import PaymentTable from "../../../containers/superadmin/paymentSubjects/table";
import { getAllPaymentsRequest } from "../../../modules/superadmin-modules/payment/Actions";

const SuperadminPayment = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllPaymentsRequest());
  }, []);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        setSearchTerm={setSearchTerm}
      />
      <PaymentTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddPayment
        isAdd={isAdd}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SuperadminPayment;
